<template>
  <div class="">
    <headerbox></headerbox>

    <div class="main">
      <hotelhead></hotelhead>
      <div class="container">
        <div class="layout">
          <menuTitle :titles="lefttitles"></menuTitle>
          <appcheck @submit="submitCheckhotel"></appcheck>
          <div v-if="loading" class="loading">
            <!-- 显示加载图片 -->
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div v-else>
            <div class="books">
              <div v-if="hotelRoom.length === 0" class="noHoteroom">
                <a
                  @click="hotelcatchbdfun('4006388880')"
                  href="tel:4006388880 "
                  data-agl-cvt="2"
                >
                  <img :src="require('assets/images/phone1.png').default" />
                  请拨打电话:400-6891109 预订客房或会议</a
                >
              </div>
              <div class="bookmain">
                <div v-for="room in sortedHotelRoom" :key="room.RoomId">
                  <!-- <template  v-if="room.plans.AvailableAmount !== '订完'"> -->
                  <div
                    class="roomlist"
                    v-for="plan in room.plans"
                    :key="plan.planid"
                  >
                    <div class="roomtitle">
                      <img v-if="room.ImageUrl" v-lazy="room.ImageUrl" />
                      <div class="roomtext">
                        <h3>{{ room.title }}</h3>
                        <p>{{ room.bed }}</p>
                      </div>
                    </div>
                    <div class="roomtips">{{ plan.planname }}</div>
                    <div class="roomprcie">
                      <small>¥</small>{{ getFormattedPrice(plan.totalprice) }}
                    </div>
                    <div
                      @click="book_click(room.RoomId, plan.planid,plan.totalprice)"
                      class="roomsubmit"
                    >
                      预订<span>（在线付）</span>
                    </div>
                  </div>
                  <!-- </template> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sides">
          <menuTitle :titles="righttitles"></menuTitle>
          <leftcheck @submit="submitCheckhotel"></leftcheck>
        </div>
      </div>
    </div>
    <footerbox></footerbox>
  </div>
</template>

<script>
import { setStorage, getStorage } from "@/common/until/until";
import { AGENT_ID } from "@/common/until/const";
import { gethotelroom, getroom } from "network/home";
import { mapMutations } from "vuex";

import footerbox from "components/content/footer";
import headerbox from "components/content/header";
import hotelhead from "components/content/hotelhead";
import leftcheck from "components/content/Leftcheck";
import appcheck from "components/content/appcheck";
import menuTitle from "components/content/menuTitle";
import moment from "moment";
export default {
  name: "Booking",

  components: {
    footerbox,
    headerbox,
    hotelhead,
    leftcheck,
    menuTitle,
    appcheck,
  },
  data() {
    return {
      righttitles: "在线酒店查询",
      lefttitles: "客房预订",
      hotelRoom: [],
      loading: false, // 控制加载状态
      loadingText: "加载中...", // 加载中的文本
      hotelnames: null, // 加载中的文本
    };
  },
  created() {
    // this.hotelcatchbdfun1();
    
  },

  mounted() {
    this.getHotelRoom();
  },
  methods: {
    ...mapMutations(["addSelectedPlan"]),
    submitCheckhotel() {
      this.getHotelRoom();
    },
    hotelcatchbdfun: function (telphone) {
      const url = window.location.href;
      console.log(url);
      const hotelname = this.$store.state.hotelinfro.hotelname;
      const address = this.$store.state.hotelinfro.address;
      const zid = this.$route.query.hid;
      let hidp = "";
      let that = this;
      let referrer = document.referrer;
      let ismobiles = "no";
      if ("ontouchstart" in document.documentElement) {
        ismobiles = "1";
      }
      let loa = encodeURIComponent(location.href);
      let hiddenProperty =
        "hidden" in document
          ? "hidden"
          : "webkitHidden" in document
          ? "webkitHidden"
          : "mozHidden" in document
          ? "mozHidden"
          : null;
      if (document[hiddenProperty]) {
        hidp = "ishide";
      } else {
        hidp = "nohide";
      }
      if (hiddenProperty == null) {
        hidp = "nullhide";
      }
      window.dispatchEvent(
        new CustomEvent("jd:getfunc", {
          detail: {
            zq: $,
            param: {
              type: "get",
              url:
                "https://api.tetuijiudian.com/bdfun.php?fun=bdfunpv&zid=" +
                zid +
                "&hidp=" +
                hidp +
                "&loa=" +
                loa +
                "&ismobiles=" +
                ismobiles +
                "&address=" +
                address +
                "&hotelname=" +
                hotelname +
                "&referrer=" +
                referrer +
                "&wap=0" +
                "&clicktel=" +
                telphone,

              dataType: "json",
              success: function (response) {},
              complete: function () {},
              error: function () {},
            },
          },
        })
      );
    },
    book_click(rid, planid,price) {
      const selectedPlan = this.hotelRoom.find((room) => room.RoomId == rid); //修改房态以前都是用RoomId
      // const selectedPlan = this.hotelRoom.find((room) => room.rid == rid);//用rid还是roomid 有争议
      const jiage= Math.floor(price * 1.1)
      this.addSelectedPlan(selectedPlan);
      setStorage("selectedPlans", JSON.stringify(selectedPlan));

      const existingParams = { ...this.$route.query };
      const newParams = {
        ...existingParams, // 将原来的参数添加到新的参数对象中
        rid: rid, // 新的rid值
        planid: planid, // 新的planid值
        price:jiage, // 新的planid值
      };

      this.$router.push({ path: "/Order", query: newParams });
    },
    async getHotelRoom() {
      const that = this;
      that.loading = true; // 显示加载状态
      const hid =
        this.$route.query.hid || getStorage("cachedId") || "defaultHid";
      const tm1 =
        this.$route.query.tm1 ||
        this.$store.state.checkInDateDefult ||
        moment(new Date()).format("YYYY-MM-DD");
      const tm2 =
        this.$route.query.tm2 ||
        this.$store.state.checkOutDateDefult ||
        moment(new Date(new Date().getTime() + 86400000)).format("YYYY-MM-DD");
      await this.$nextTick();
      let urls = "http://81.70.247.104/e/json.php";
      const greenhotelid = [
        1834690, 2602495, 1606783, 2669469, 1881308, 1879993, 2607688, 2672173,
        1979235, 1985723, 1915754, 1788476, 1684158, 2689625, 1780852, 2611180,
        1811671, 2308732, 1652467, 2651287, 1813917, 1839705, 1617655, 2579276,
        1822710, 1836637, 1755133, 1764059, 1789654, 1684239, 2613062, 1814582,
      ];
      for (let i = 0; i < greenhotelid.length; i++) {
        if (greenhotelid[i] == hid) {
          urls = "http://81.70.247.104/e/json.php";
          break; // 找到匹配项后退出循环
        }
      }
      try {
        $.ajax({
          url: urls, // 替换为你的实际 API 端点
          method: "GET",
          dataType: "jsonp",
          data: {
            tm1,
            tm2,
            hid,
            agent_id: AGENT_ID,
          },
          success: function (res) {
            that.loading = false; // 显示加载状态
            that.hotelnames = res[0].hotelname;

            that.$store.dispatch("updateHotelName", res[0].hotelname);
            setStorage("hotelnameinfro", res[0].hotelname);
            console.log(res.hotelname);
            if (res[0].rooms && res[0].rooms.length > 0) {
              const filteredRooms = res[0].rooms.map((room) => {
                const filteredPlans = room.plans.filter(
                  (plan) => plan.AvailableAmount !== "订完"
                );
                return { ...room, plans: filteredPlans };
              });
              that.hotelRoom = filteredRooms;
              // that.hotelcatchbdfun1();
            } else {
              that.$store.commit("setHotelPhone", "400-6891109");
              localStorage.setItem("hotelphone", "400-6891109");
              that.hotelRoom = [];
            }
          },
          error: function (error) {
            console.error("Error fetching hotel data:", error);
          },
        });
      } catch (error) {
        console.error("Error fetching hotel data:", error);
      }
    },
  },
  computed: {
    sortedHotelRoom() {
      if (this.hotelRoom.length === 0) {
        return []; // 如果hotelRoom数组为空，直接返回空数组
      }
      console.log(this.hotelRoom);
      return this.hotelRoom.sort((a, b) => {
        // const priceA = a.plans[0].totalprice; // 假设取每个房间的第一个计划的价格进行比较
        // const priceB = b.plans[0].totalprice;
        // return priceA - priceB;
        const priceA = Math.min(...a.plans.map((plan) => plan.totalprice));
        const priceB = Math.min(...b.plans.map((plan) => plan.totalprice));
        return priceA - priceB;
      });
    },
    getFormattedPrice() {
      return function (price) {
        const formattedPrice = Math.floor(price * 1.1);
        return formattedPrice;
      };
    },
  },
};
</script>
<style lang="less" scoped>
html,
body {
  min-height: 100vh;
}
.books {
  min-height: 60vh;
  .bookmain {
    border-bottom: 1px solid #dbdbdb;
  }
}
.noHoteroom {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30vh;
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    background: #f1f1f1;
    padding: 20px;
    border-radius: 20px;
  }
  img {
    width: 50px;
    margin-right: 20px;
  }
}
.roomlist {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  border: 1px solid #dbdbdb;
  padding-right: 18px;
  border-bottom: none;
  .roomtips {
    min-width: 120px;
    text-align: center;
  }
  .roomtitle {
    display: flex;
    justify-content: flex-start;
    // background: #f8f8f8;
    padding: 5px;
    width: 200px;

    img {
      width: 68px;
      height: 68px;
    }
    .roomtext {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .roomtext {
      padding-left: 15px;
      h3 {
        padding: 5px 0;
        word-break: break-all;
        line-height: 21px;
      }
      p {
        color: #888888;
      }
    }
  }
  .roomprcie {
    font-size: 20px;
    font-family: Arial;
    font-weight: bold;
    color: #ff5555;
    small {
      font-size: 12px;
    }
  }
  .roomsubmit {
    width: 110px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #ff5555;
    border-radius: 3px;
    font-size: 16px;
    font-weight: 400;
    color: #fcf9f9;
    text-align: center;
    cursor: pointer;
    span {
      font-size: 12px;

      font-weight: 400;
      color: #ffffff;
    }
  }
}
// .bookdate{
//   display: flex;
//   justify-content: space-between;
//   .datedetail{
//     width: 48%;
//     p{
//       line-height: 32px;
//     }
//     ::v-deep  .el-date-editor.el-input,::v-deep  .el-date-editor.el-input__inner{
//       width: 100%;
//     }
//     ::v-deep .el-input__inner {
//          width: 100%;
//         color: #000;
//       }
//   }
// }

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60%;

  span {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-color: #3498db;
    border-radius: 50%;
    opacity: 0;
    animation: scale 1s ease-in-out infinite;
    animation-delay: 0s, 0.25s, 0.5s; /* 每个元素延迟不同的时间 */
    margin: 0 5px;
  }

  @keyframes scale {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.3;
      transform: scale(0.5);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
}

@media (min-width: 320px) and (max-width: 768px) {
  .books {
    border: none;
    .bookmain {
      border: none;
    }
  }
  .roomtips {
    display: none;
  }
  .roomlist {
    padding: 5px 0;
    border: none;
    .roomsubmit {
      width: 60px;
      span {
        display: none;
      }
    }
  }
  .noHoteroom {
    margin-bottom: 50%;
    a {
      padding: 20px 10px;
      font-size: 14px;
      img {
        width: 30px;
        margin-right: 5px;
      }
    }
  }
  .loading {
    height: 70vh;
  }
}
</style>


 
 